import { userIntentPluginKey } from '../pm-plugins/main';
export var setCurrentUserIntent = function setCurrentUserIntent(currentUserIntent) {
  return function (_ref) {
    var tr = _ref.tr;
    tr.setMeta(userIntentPluginKey, {
      type: 'setCurrentUserIntent',
      data: {
        currentUserIntent: currentUserIntent
      }
    });
    return tr;
  };
};